import '../../node_modules/magnific-popup';
    
$('#bouton-contact-mobile').magnificPopup({
    type:'inline'
});


$('#button-contact-menu-sticky').magnificPopup({
    type:'inline'
});

$('.bouton-voir-mon-agence').on('click',function(e) {
    if (typeof(Kinougarde.agence)!=='undefined' && Kinougarde.agence!==null ) {
        document.location.href = Kinougarde.agence.Url;
    }
});